"use client";
import styled from "styled-components";
import Title from "@/components/Title";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import Button from "@/components/Button";
import { Loading } from "@/components/Loading";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Link from "next/link";

const UTradeForm = ({ data }) => {
  const [IsSubmitting, setIsSubmitting] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setIsSubmitting(false);
    }, 300);
  }, []);

  const { register, handleSubmit, formState, reset } = useForm({ mode: "all" });
  const { errors, isSubmitSuccessful, isSubmitting } = formState;

  //--- form submit

  const success = (msg) =>
    toast.success(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      progress: undefined,
    });

  const error = (msg) =>
    toast.error(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      progress: undefined,
    });

  const onSubmit = async (data) => {
    setIsSubmitting(true); // Show spinner
    try {
      const formData = new FormData();
      formData.append("_wpcf7_unit_tag", "form_" + "6927");
      formData.append("investor", data?.investor);
      formData.append("email", data?.email);
      formData.append("phone", data?.phone);

      const response = await axios.post(
        "https://cms.ucbstock.com.bd//wp-json/contact-form-7/v1/contact-forms/6927/feedback",
        formData
      );
      if (response.status === 200) {
        success(response?.data?.message);
        reset(); // Reset form fields
      } else {
        error("Failed to submit form. Please try again later.");
      }
    } catch (err) {
      error(
        err?.message
          ? err?.message
          : "Failed to submit form. Please try again later."
      );
    } finally {
      setIsSubmitting(false); // Hide spinner
    }
  };

  const onError = (errors) => {
    // setToastShown(false); // Reset toast shown state on new submission attempt
    const firstError = Object.values(errors)[0];
    error(firstError.message);
  };

  return (
    <StyledUtradForm
      className={"pt-200 pb-200 horizontal-scroll"}
      data-speed-right={30}
      data-speed-left={-30}
    >
      {IsSubmitting && <Loading />}
      <Container>
        <p className={"parallax-xr bg-text-one"}>Sign</p>
        <p className={"parallax-x bg-text-two"}>Up</p>
        <Row>
          <Col md={4}>
            <img height={30} style={{
              marginBottom: "20px",
            }} src="/images/static/utrade-main.svg" alt="UTrade Sign Up"/>
            <Title margin={'0 0 30px'} text={"Sign Up for UTrade"} />
            <p>
              Start your investment journey with UTrade by UCB Stock Brokerage Ltd., one of Bangladesh’s leading brokerage firms. Our secure and user-friendly platform makes trading simple, fast, and reliable.
              
              With UTrade, enjoy seamless trading, expert market insights, and powerful tools designed to help you make smarter investment decisions. Whether you’re monitoring the market or executing trades, UTrade keeps you in control—anytime, anywhere.
            </p>
            <ul className={'d-flex justify-content-start flex-wrap align-items-center mt-5'} style={{
              gap: '30px',
              color: 'inherit',
            }}>
              <Link style={{
                color: 'inherit',
              }} className={'d-flex flex-column text-center align-items-center'} href={'https://play.google.com/store/apps/details?id=com.xfltrade.ubr&hl=en'} target={'_blank'}>
                <svg width="40px" height="40px" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <mask id="mask0_87_8320" maskUnits="userSpaceOnUse" x="7" y="3" width="24" height="26">
                      <path
                        d="M30.0484 14.4004C31.3172 15.0986 31.3172 16.9014 30.0484 17.5996L9.75627 28.7659C8.52052 29.4459 7 28.5634 7 27.1663L7 4.83374C7 3.43657 8.52052 2.55415 9.75627 3.23415L30.0484 14.4004Z"
                        fill="#C4C4C4"></path>
                    </mask>
                    <g mask="url(#mask0_87_8320)">
                      <path
                        d="M7.63473 28.5466L20.2923 15.8179L7.84319 3.29883C7.34653 3.61721 7 4.1669 7 4.8339V27.1664C7 27.7355 7.25223 28.2191 7.63473 28.5466Z"
                        fill="url(#paint0_linear_87_8320)"></path>
                      <path
                        d="M30.048 14.4003C31.3169 15.0985 31.3169 16.9012 30.048 17.5994L24.9287 20.4165L20.292 15.8175L24.6923 11.4531L30.048 14.4003Z"
                        fill="url(#paint1_linear_87_8320)"></path>
                      <path
                        d="M24.9292 20.4168L20.2924 15.8179L7.63477 28.5466C8.19139 29.0232 9.02389 29.1691 9.75635 28.766L24.9292 20.4168Z"
                        fill="url(#paint2_linear_87_8320)"></path>
                      <path
                        d="M7.84277 3.29865L20.2919 15.8177L24.6922 11.4533L9.75583 3.23415C9.11003 2.87878 8.38646 2.95013 7.84277 3.29865Z"
                        fill="url(#paint3_linear_87_8320)"></path>
                    </g>
                    <defs>
                      <linearGradient id="paint0_linear_87_8320" x1="15.6769" y1="10.874" x2="7.07106" y2="19.5506"
                                      gradientUnits="userSpaceOnUse">
                        <stop stopColor="#00C3FF"></stop>
                        <stop offset="1" stopColor="#1BE2FA"></stop>
                      </linearGradient>
                      <linearGradient id="paint1_linear_87_8320" x1="20.292" y1="15.8176" x2="31.7381" y2="15.8176"
                                      gradientUnits="userSpaceOnUse">
                        <stop stopColor="#FFCE00"></stop>
                        <stop offset="1" stopColor="#FFEA00"></stop>
                      </linearGradient>
                      <linearGradient id="paint2_linear_87_8320" x1="7.36932" y1="30.1004" x2="22.595" y2="17.8937"
                                      gradientUnits="userSpaceOnUse">
                        <stop stopColor="#DE2453"></stop>
                        <stop offset="1" stopColor="#FE3944"></stop>
                      </linearGradient>
                      <linearGradient id="paint3_linear_87_8320" x1="8.10725" y1="1.90137" x2="22.5971" y2="13.7365"
                                      gradientUnits="userSpaceOnUse">
                        <stop stop-color="#11D574"></stop>
                        <stop offset="1" stop-color="#01F176"></stop>
                      </linearGradient>
                    </defs>
                  </g>
                </svg>
                <span>Google Play Store</span>
              </Link>
              <Link style={{
                color: 'inherit',
              }}  className={'d-flex flex-column text-center align-items-center'} href={'https://apps.apple.com/us/app/utrade-by-ucb-stock/id6753627888'} target={'_blank'}>
                <svg width="40px" height="40px" viewBox="0 0 32 32" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <circle cx="16" cy="16" r="14" fill="url(#paint0_linear_87_8317)">
                    
                    </circle>
                    <path
                      d="M18.4468 8.65403C18.7494 8.12586 18.5685 7.45126 18.0428 7.14727C17.5171 6.84328 16.8456 7.02502 16.543 7.55318L16.0153 8.47442L15.4875 7.55318C15.1849 7.02502 14.5134 6.84328 13.9877 7.14727C13.462 7.45126 13.2811 8.12586 13.5837 8.65403L14.748 10.6864L11.0652 17.1149H8.09831C7.49173 17.1149 7 17.6089 7 18.2183C7 18.8277 7.49173 19.3217 8.09831 19.3217H18.4324C18.523 19.0825 18.6184 18.6721 18.5169 18.2949C18.3644 17.7279 17.8 17.1149 16.8542 17.1149H13.5997L18.4468 8.65403Z"
                      fill="white"></path>
                    <path
                      d="M11.6364 20.5419C11.449 20.3328 11.0292 19.9987 10.661 19.8888C10.0997 19.7211 9.67413 19.8263 9.45942 19.9179L8.64132 21.346C8.33874 21.8741 8.51963 22.5487 9.04535 22.8527C9.57107 23.1567 10.2425 22.975 10.5451 22.4468L11.6364 20.5419Z"
                      fill="white"></path>
                    <path
                      d="M22.2295 19.3217H23.9017C24.5083 19.3217 25 18.8277 25 18.2183C25 17.6089 24.5083 17.1149 23.9017 17.1149H20.9653L17.6575 11.3411C17.4118 11.5757 16.9407 12.175 16.8695 12.8545C16.778 13.728 16.9152 14.4636 17.3271 15.1839C18.7118 17.6056 20.0987 20.0262 21.4854 22.4468C21.788 22.975 22.4594 23.1567 22.9852 22.8527C23.5109 22.5487 23.6918 21.8741 23.3892 21.346L22.2295 19.3217Z"
                      fill="white"></path>
                    <defs>
                      <linearGradient id="paint0_linear_87_8317" x1="16" y1="2" x2="16" y2="30"
                                      gradientUnits="userSpaceOnUse">
                        <stop stopColor="#2AC9FA"></stop>
                        <stop offset="1" stopColor="#1F65EB"></stop>
                      </linearGradient>
                    </defs>
                  </g>
                </svg>
                <span>App Store</span>
              </Link>
            </ul>
          
          </Col>
          <Col md={8}>
            <Form className={"form"} onSubmit={handleSubmit(onSubmit, onError)}>
              <div className="form-group">
                <Form.Group controlId="formBasicEmail">
                  <Form.Control
                    className={
                      formState?.errors?.investor?.message
                        ? "has-error form-control-lg"
                        : "form-control-lg"
                    }
                    {...register("investor", {
                      required: "Investor code is required",
                    })}
                    type="text"
                    placeholder="Investor code*"
                    disabled={isSubmitting}
                  />
                  {errors.investor && (
                    <span className="error-message form-error">
                      {errors.investor.message}
                    </span>
                  )}
                </Form.Group>
              </div>
              <div className="form-group">
                <Form.Group controlId="formBasicEmail">
                  <Form.Control
                    className={
                      formState?.errors?.email?.message
                        ? "has-error form-control-lg"
                        : "form-control-lg"
                    }
                    {...register("email", {
                      required: {
                        value: true,
                        message: "Enter a valid email address",
                      },
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Enter a valid email address",
                      },
                    })}
                    type="email"
                    placeholder="Email*"
                    disabled={isSubmitting}
                  />
                  {errors.email && (
                    <span className="error-message form-error">
                        {errors.email.message}
                      </span>
                  )}
                </Form.Group>
              </div>
              <div className="form-group">
                <Form.Group controlId="formBasicPhone">
                  <Form.Control
                    className={
                      formState?.errors?.phone?.message
                        ? "has-error form-control-lg"
                        : "form-control-lg"
                    }
                    {...register("phone", {
                      required: {
                        value: true,
                        message: "Enter your phone number",
                      },
                      pattern: {
                        value: /^01[0-9]{9}$/,
                        message: "Enter a valid 11 digit phone number",
                      },
                    })}
                    type="number"
                    placeholder="Phone Number*"
                    disabled={isSubmitting}
                  />
                  {errors.phone && (
                    <span className="error-message form-error">
                        {errors.phone.message}
                      </span>
                  )}
                </Form.Group>
              </div>


              <div
                className={`form-group width-fit ${
                  isSubmitting ? "disabled" : ""
                }`}
              >
                <div
                  style={{ width: "fit-content" }}
                  onClick={handleSubmit(onSubmit, onError)}
                >
                  <Button src={"javascript:void(0)"} text={"Submit"} />
                </div>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </StyledUtradForm>
  );
};

const StyledUtradForm = styled.section`
  background-color: #f4f4f4;
  position: relative;

  .form-group {
    margin-bottom: 30px;

    &:last-child {
      margin-bottom: 0;
    }

    .form-control {
      box-shadow: none;
      outline: 0;
      border-radius: 0;
      background: transparent;
      height: auto;
      border-left: none;
      border-right: none;
      border-top: none;
      border-color: rgba(198, 198, 198, 0.5);
      padding: 0 0 8px;
      color: #3c3c3b;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;

      &:focus {
        border-color: #3c3c3b;
      }

      &::placeholder {
        color: #c6c6c6;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }
    }

    textarea {
      min-height: 80px;
    }
  }

  .phoneEmail {
    display: flex;
    gap: 25px;
    .form-group {
      flex: 0 0 49%;
    }
    @media (max-width: 767px) {
      flex-direction: column;
      gap: 0px;
      .form-group {
        flex: 0 0 100%;
        &:last-child {
          margin-bottom: 30px;
        }
      }
    }
  }

  .bg-text-one,
  .bg-text-two {
    font-size: 200px;
    line-height: 250px;
    font-weight: 700;
    margin: 0;
    color: rgba(25, 25, 25, 0.05);
    position: absolute;
    white-space: nowrap;
    font-family: "Aeonik", Euclid Square, Arial, Helvetica, freesans, sans-serif;

    @media (max-width: 767px) {
      font-size: 120px;
      line-height: 120px;
    }
  }
  .bg-text-one {
    right: 0;
    top: 165px;
  }

  .bg-text-two {
    left: 600px;
    bottom: 125px;
  }

  @media (max-width: 767px) {
    padding-bottom: 60px;
    .bg-text-one,
    .bg-text-two {
      display: none;
    }
  }

  form {
    @media (max-width: 767px) {
      margin-bottom: 40px;
    }
  }
`;

export default React.memo(UTradeForm);
